import React from 'react';
import { Skeleton } from '@mui/material';
import styles from './PackageList.module.css';

/** Carregando: o mesmo cartão da lista, com linhas em esqueleto. */
function PackagesLoading() {
  return (
    <section className={styles.card} aria-busy="true" aria-label="Carregando pacotes">
      <header className={styles.header}>
        <Skeleton variant="text" width={120} height={24} />
        <Skeleton variant="text" width={90} height={20} />
      </header>
      {[0, 1, 2].map((row) => (
        <div key={row} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '14px 20px', borderTop: row ? '1px solid #f1f3f8' : 'none' }}>
          <Skeleton variant="rounded" width={38} height={38} sx={{ borderRadius: '10px' }} />
          <div style={{ flex: 1 }}>
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="text" width="25%" height={16} />
          </div>
          <Skeleton variant="rounded" width={90} height={22} sx={{ borderRadius: '999px' }} />
          <Skeleton variant="text" width={70} height={20} />
        </div>
      ))}
    </section>
  );
}

export default PackagesLoading;
